<template>
  <div class="area">
    <div class="area_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">学科领域</div>
      <div class="determine" @click="ondetermine">确定</div>
    </div>
    <div class="area_bottm">
      <van-field
        center
        style="border-radius: 8px; height: 48px"
        v-model="form.fieldValue"
        is-link
        readonly
        label="学科领域"
        placeholder="请输入"
        @click="show = true"
      />
      <div class="search">
        <van-popup v-model="show" round position="bottom">
          <van-search
            v-model="keyword"
            placeholder="请输入关键字"
            @search="onSearch"
          />
          <van-cascader
            v-model="cascaderValue"
            title="请选择学科领域"
            :options="options"
            @close="show = false"
            @finish="onFinish"
            :field-names="fieldNames"
            active-color="#397BF9"
          />
        </van-popup>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { Toast } from "vant";
export default {
  name: "area",
  data() {
    return {
      show: false,
      userInfo: "",
      keyword: "",
      form: {
        fieldValue: "",
      },
      cascaderValue: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      fieldNames: {
        text: "label",
        value: "value",
        children: "children",
      },
      options: [],
      level: {
        levelOne: 0,
        levelTwo: 0,
      },
    };
  },
  created() {
    if (sessionStorage.getItem("scholarUserInfos")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
    } else {
      sessionStorage.setItem(
        "scholarUserInfos",
        sessionStorage.getItem("scholarUserInfo")
      );
    }
    this.getRelationList();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;

      this.level.levelOne = selectedOptions[0].value;
      this.level.levelTwo = selectedOptions[1].value;

      this.form.fieldValue = selectedOptions
        .map((option) => option.label)
        .join(",");
    },
    onSearch() {
      this.filteredOptions = this.options.filter((option) => {
        return option.name.indexOf(this.keyword) !== -1;
      });
      this.columns[0].values = this.filteredOptions.map(
        (option) => option.label
      );
    },
    async getRelationList() {
      const data = await this.$apis.userServe.getRelationList();
      this.options = data.data;
    },
    ondetermine() {
      if (!this.userInfo.sysUserSubject) {
        this.userInfo.sysUserSubject = [];
      }
      if (this.form.fieldValue == "") {
        Toast("学科领域不能为空");
      } else {
        this.userInfo.sysUserSubject.push({
          levelOneName: this.form.fieldValue.split(",")[0],
          levelTwoName: this.form.fieldValue.split(",")[1],
          levelOne: this.level.levelOne,
          levelTwo: this.level.levelTwo,
        });
        sessionStorage.setItem(
          "scholarUserInfos",
          JSON.stringify(this.userInfo)
        );
        this.$router.push("information");
      }
    },
  },
};
</script>
    
    <style lang="scss">
body,
html {
  background: #f5f5f5;
}
.area {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .area_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;
    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }
    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }
  .area_bottm {
    width: 94%;
    margin: 12px auto;
    background: #fff;
    border-radius: 8px;
  }
  .prompt {
    width: 94%;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin: 0 auto;
  }
}
</style>